import React from 'react';
import { colors } from '@guryou/colors';
import { Modal, Icon } from '../../components/shared';
import WidgetClassSessions from './WidgetClassSessions';
import WidgetSubscription from './WidgetSubscription';

const AccordionDetailsCourse = ({ subservice, sessionActiveStep, closeModal }) => {
  // Get primaryColor from WidgetContext if needed
  // For now, using default colors since this is a modal component
  const primary = 'var(--feel-primary)';
  const secondary = colors.cabaret;

  return (
    <Modal isOpen={true} onClose={closeModal} title={subservice?.name} maxWidth="4xl">
      <div className="p-6">
        {/* Course Header */}
        <div
          className="relative overflow-hidden rounded-2xl p-6 mb-8 shadow-lg"
          style={{ background: `linear-gradient(to bottom right, ${primary}, ${secondary})` }}
        >
          {/* Decorative elements */}
          <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full -translate-y-16 translate-x-16"></div>
          <div className="absolute bottom-0 left-0 w-24 h-24 bg-white/5 rounded-full translate-y-12 -translate-x-12"></div>

          <div className="relative z-10">
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-3">
                <div className="p-2 bg-white/20 rounded-lg backdrop-blur-sm">
                  <Icon name="book" size="md" color="white" />
                </div>
                <div>
                  <p className="text-white/90 text-sm font-medium">Course Details</p>
                  <p className="text-white/70 text-xs">{subservice?.name}</p>
                </div>
              </div>
              <div className="text-right">
                <span className="text-2xl font-bold text-white">Course</span>
                <p className="text-white/80 text-xs mt-1">Interactive Learning</p>
              </div>
            </div>
          </div>
        </div>

        {/* Course Content */}
        <div className="space-y-6">
          {sessionActiveStep === 0 && <WidgetClassSessions gyClass={subservice} />}
          {sessionActiveStep === 1 && <WidgetSubscription gyClass={subservice} closeModal={closeModal} />}
        </div>
      </div>
    </Modal>
  );
};

export default AccordionDetailsCourse;
